
import {
	clearData,
	pendingDispenseRemovingPageNumber
} from "../../slices/dispense/patientPendingList";

import { createAsyncThunk } from "@reduxjs/toolkit";
import { driver_confirm_delivery } from "../../../networking/urlEndPoints";
import { fetchPatientPendingList } from "./patientPendingList";

import {
	clearAllTodayDispenseData,
	todayDispenseRemovingPageNumber,
	removeTodayDispenePatientById,
} from "../../slices/dispense/patientForRouteList";

import { removePatientById } from "../../slices/dispense/patientPendingList";
import { removeFlexiDeliverById } from "../../slices/dispense/flexiDeliver";
import { removeVitalPatientById } from "../../slices/dispense/vitalPatients";

import { fetchPatientlistOnBasisOfRoute } from "./patientsForRouteLIst";
import { fetchTodayMissed } from "./todayMissed";
import { requestDoseGapOverride } from "../../../utils/helper/doseGapPrompt";
import Axios from "../../../networking/interceptor";
import { extractNestedApiErrorMessage } from "../../../utils/helper/apiErrorMessage";

export const confirmDelivery = createAsyncThunk(
	'confirmDelivery',
	async (requesteData, { rejectWithValue }) => {

	const {
		frequency_dose_id,
		gap_override_confirmed,
		gap_override_reason,
		pharmacy_id,
		patient_sign,
		pharmacist_sign,
		delivery_latitude,
		delivery_longitude,
		comment,
		is_refused,
		is_return,
		front_delivery_time,
		isTransferRequest,
		patient_id,
		setShowSuccessToast,
		type,
		setOpenIndex,
		setIsTransferRequest,
		setShowErrorToast,
		setLoading,
		dispatch,
		consultation,
		new_rx_counselling_values,
		flexi_rx_refill_id,
		hasFlexOnly,
		flexi_proof_images,
		payment_options,
		is_patient_verified,
		deliver_rx_ids,
		has_selected_deliver_rx_ids,
		unconsumed_doses,
		tab,
		patientCardScrollIndex,
	} = requesteData;

	try {
		/* ---------------- Payload (UNCHANGED) ---------------- */
		const payloadData = {
			pharmacy_id,
			patient_sign,
			pharmacist_sign,
			delivery_latitude,
			delivery_longitude,
			comment,
			is_refused,
			is_return,
			is_patient_verified: Boolean(is_patient_verified),
			front_delivery_time,
		};

		if (hasFlexOnly === 'flexi_deliver') {
			payloadData.only_fexi = true;
			payloadData.track_page = 'flexi_tab';
		} else {
			payloadData.only_fexi = false;
			const typeMap = {
				today_dispense: 'today_dispense',
				pending_dispense: 'pending_dispense',
				patient_search_list: 'searched_dispense',
				today_missed: 'today_missed',
				final_missed: 'final_missed'
			};
			payloadData.track_page = typeMap[type] || '';
		}

		// Tells the server this app can show the early-dose popup. Without it
		// the server assumes an app from before the popup and keeps the delivery
		// rules that app was built for, so a driver who has not reloaded is
		// never refused with no way through.
		payloadData.dose_gap_supported = true;

		if (frequency_dose_id?.length > 0) {
			payloadData.frequency_dose_id = frequency_dose_id;
		}

		// Set when the driver confirmed delivering a dose before the
		// prescription's required separation had elapsed. The reason is
		// mandatory alongside it and is kept on the dose row.
		if (gap_override_confirmed) {
			payloadData.gap_override_confirmed = true;
			payloadData.gap_override_reason = gap_override_reason;
		}

		if (isTransferRequest) {
			payloadData.to_pharmacy_id = pharmacy_id;
		}

		if (consultation?.value) {
			payloadData.counsult_text = consultation.value;
		}

		if (new_rx_counselling_values?.length > 0) {
			const notes = {};
			new_rx_counselling_values.forEach(({ rxid, dropdownValue }) => {
				if (dropdownValue?.value) {
					notes[rxid] = dropdownValue.value;
				}
			});
			payloadData.pending_counseling_note = notes;
		}

		if (flexi_rx_refill_id?.length > 0) {
			payloadData.flexi_rx_refill_id = flexi_rx_refill_id;
		}

		if (payment_options && payment_options?.length > 0) {
			payloadData.payment_options = payment_options;
		}

		if (has_selected_deliver_rx_ids === true) {
			payloadData.winrx_data_id = deliver_rx_ids || [];
			payloadData.has_selected_deliver_rx_ids = true;
		} else if (deliver_rx_ids?.length > 0) {
			payloadData.winrx_data_id = deliver_rx_ids;
		}

		if (unconsumed_doses?.length > 0) {
			payloadData.unconsumed_doses = unconsumed_doses;
		}

		/* ---------------- API CALL (ONLY CHANGE) ---------------- */
		// The gap is re-checked server side at the moment of writing, so a
		// delivery can be refused after the list was drawn: the previous dose
		// may have gone out since, or several doses may be going out together.
		// That refusal carries the whole dialog, so it is raised here and the
		// request repeated with the reason, rather than shown as an error.
		const sendDelivery = async (extraPayload = {}) => {
			const body = { ...payloadData, ...extraPayload };

			if (!(flexi_proof_images && Object?.keys(flexi_proof_images)?.length > 0)) {
				return Axios.post(`${driver_confirm_delivery}/${patient_id}`, body);
			}

			const formData = new FormData();

			// Helper function to recursively append values to FormData
			const appendToFormData = (key, value) => {
				if (value === null || value === undefined) {
					formData.append(key, '');
					return;
				}

				if (Array.isArray(value)) {
					value.forEach((v, i) => {
						appendToFormData(`${key}[${i}]`, v);
					});
				} else if (typeof value === 'object' && value !== null) {
					// Handle nested objects recursively
					Object.entries(value).forEach(([k, v]) => {
						if (typeof v === 'object' && v !== null && !Array.isArray(v) && !(v instanceof File) && !(v instanceof Blob)) {
							// Nested object - recursively append
							Object.entries(v).forEach(([nestedKey, nestedValue]) => {
								appendToFormData(`${key}[${k}][${nestedKey}]`, nestedValue);
							});
						} else {
							// Primitive value or File/Blob
							appendToFormData(`${key}[${k}]`, v);
						}
					});
				} else {
					// Primitive values (string, number, boolean)
					// FormData serializes booleans as the strings "true"/"false", which
					// Laravel's boolean validator does not accept. Send the standard 1/0
					// representation instead.
					formData.append(key, typeof value === 'boolean' ? (value ? '1' : '0') : value);
				}
			};

			// append existing payload, including whatever a retry adds: a
			// confirmed dose gap has to reach the server on this path too, or
			// the retry is refused exactly as the first attempt was.
			Object.entries(body).forEach(([key, value]) => {
				appendToFormData(key, value);
			});

			// append proof images [{id, image}]
			Object.values(flexi_proof_images).forEach((item, index) => {
				formData.append(`flexi_proof_images[${index}][id]`, item.id);
				formData.append(`flexi_proof_images[${index}][image]`, item.file);
			});

			return Axios.post(
				`${driver_confirm_delivery}/${patient_id}`,
				formData,
				{ headers: { "Content-Type": "multipart/form-data" } }
			);
		};

		let response;

		try {
			response = await sendDelivery();
		} catch (deliveryError) {
			const prompt = deliveryError?.response?.status === 409
				? deliveryError?.response?.data?.data?.error
				: null;

			if (!prompt?.requires_confirmation && !prompt?.requires_gap_confirmation) {
				throw deliveryError;
			}

			const confirmation = await requestDoseGapOverride(prompt);
			if (!confirmation?.confirmed) {
				// Cancelling is a decision, so the screen is left as it is. Not
				// being asked at all is not: the server refused and the driver
				// would otherwise see nothing, so it falls through to the error
				// handling below and the refusal is shown.
				if (!confirmation?.shown) {
					throw deliveryError;
				}

				if (typeof setLoading === 'function') setLoading(false);
				return rejectWithValue(deliveryError.response);
			}

			response = await sendDelivery({
				gap_override_confirmed: true,
				gap_override_reason: confirmation.reason,
			});
		}

		const responseBody = response?.data;
		const nestedBusinessMsg = extractNestedApiErrorMessage(responseBody);
		if (responseBody?.success === false) {
			if (typeof setShowErrorToast === 'function') {
				setShowErrorToast(true);
				setTimeout(() => setShowErrorToast(false), 8000);
			}
			return rejectWithValue({
				userFacingMessage: nestedBusinessMsg || null,
			});
		}

		/* ---------------- UI / FLOW (after successful API) ---------------- */
		if (type === 'today_dispense') {
			dispatch(removeTodayDispenePatientById(patient_id));
			if (typeof setShowSuccessToast === 'function') {
				setShowSuccessToast(true);
				setTimeout(() => setShowSuccessToast(false), 2000);
			}
		} else if (type === 'pending_dispense') {
			dispatch(removePatientById(patient_id));
			if (typeof setShowSuccessToast === 'function') {
				setShowSuccessToast(true);
				setTimeout(() => setShowSuccessToast(false), 2000);
			}
		} else if (type === 'flexi_deliver') {
			dispatch(removeFlexiDeliverById(patient_id));
			if (typeof setShowSuccessToast === 'function') {
				setShowSuccessToast(true);
				setTimeout(() => setShowSuccessToast(false), 2000);
			}
		} else if (type === 'add_vital') {
			dispatch(removeVitalPatientById(patient_id));
			if (typeof setShowSuccessToast === 'function') {
				setShowSuccessToast(true);
				setTimeout(() => setShowSuccessToast(false), 2000);
			}
		}

		if (
			typeof setShowSuccessToast === 'function' &&
			type !== 'pending_dispense' &&
			type !== 'today_dispense' &&
			type !== 'flexi_deliver' &&
			type !== 'add_vital'
		) {
			setShowSuccessToast(true);
			setTimeout(() => setShowSuccessToast(false), 3000);
		}

		if (
			typeof patientCardScrollIndex === 'number' &&
			(type === 'today_dispense' || type === 'pending_dispense' || type === 'flexi_deliver' || type === 'add_vital')
		) {
			const scrollFromIndex = patientCardScrollIndex;
			setTimeout(() => {
				const nextPatientCard = document.getElementById(`patientCard-${scrollFromIndex + 1}`);
				if (nextPatientCard) {
					nextPatientCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}
			}, 100);
		}

		if (type === 'patient_search_list') {
			setTimeout(() => window.history.back(), 1000);
		}

		if (type === 'today_missed' && pharmacy_id) {
			dispatch(fetchTodayMissed({ pharmacy_id, status: 'today_missed', ...(tab ? { tab } : {}) }));
		}

		if (type === 'final_missed' && pharmacy_id) {
			dispatch(fetchTodayMissed({ pharmacy_id, status: 'final_missed', ...(tab ? { tab } : {}) }));
		}

		if (typeof setOpenIndex === 'function') {
			setOpenIndex(null);
		}

		if (typeof setIsTransferRequest === 'function') {
			setIsTransferRequest(null);
		}

		return response;

	} catch (error) {
		const resData = error?.response?.data;
		const nestedMsg = extractNestedApiErrorMessage(resData);
		if (nestedMsg) {
			if (typeof setShowErrorToast === 'function') {
				setShowErrorToast(true);
				setTimeout(() => setShowErrorToast(false), 8000);
			}
			return rejectWithValue({ userFacingMessage: nestedMsg });
		}

		const topLevelMsg = typeof resData?.message === 'string' && resData.message.trim() ? resData.message.trim() : '';
		if (topLevelMsg) {
			window.alert(topLevelMsg);
		}

		if (typeof setShowErrorToast === 'function') {
			setShowErrorToast(true);
			setTimeout(() => setShowErrorToast(false), 3000);
		}

		if (type === 'pending_dispense') {
			setLoading?.(true);
			dispatch(clearData());
			dispatch(pendingDispenseRemovingPageNumber());
			dispatch(fetchPatientPendingList({
				page: 1,
				pharmacy_id,
				setLoading
			}));
		}

		if (type === 'today_dispense') {
			dispatch(clearAllTodayDispenseData());
			dispatch(todayDispenseRemovingPageNumber());

			requesteData?.params?.setLoading?.(true);

			dispatch(fetchPatientlistOnBasisOfRoute({
				route: requesteData?.params?.route,
				pharmacy_id,
				setLoading: requesteData?.params?.setLoading,
			}));
		}

		return rejectWithValue({ userFacingMessage: null, inner: error.response });
	}
});







// import {
// 	clearData,
// 	pendingDispenseRemovingPageNumber
// } from "../../slices/dispense/patientPendingList";

// import { createAsyncThunk } from "@reduxjs/toolkit";
// import { driver_confirm_delivery } from "../../../networking/urlEndPoints";
// import { fetchPatientPendingList } from "./patientPendingList";

// import {
// 	clearAllTodayDispenseData,
// 	todayDispenseRemovingPageNumber
// } from "../../slices/dispense/patientForRouteList";

// import { fetchPatientlistOnBasisOfRoute } from "./patientsForRouteLIst";

// import Axios from "../../../networking/interceptor";

// export const confirmDelivery = createAsyncThunk('confirmDelivery', async (requesteData, { rejectWithValue }) => {

// 	const { frequency_dose_id,
// 		pharmacy_id,
// 		patient_sign,
// 		pharmacist_sign,
// 		delivery_latitude,
// 		delivery_longitude,
// 		comment,
// 		is_refused,
// 		front_delivery_time,
// 		is_return,
// 		isTransferRequest,
// 		patient_id,
// 		setShowSuccessToast,
// 		type,
// 		setOpenIndex,
// 		setIsTransferRequest,
// 		setShowErrorToast,
// 		setLoading,
// 		dispatch,
// 		consultation,
// 		new_rx_counselling_values,
// 		flexi_rx_refill_id,
// 		hasFlexOnly
// 	} = requesteData

// 	try {

// 		const payloadData = {
// 			pharmacy_id: pharmacy_id,
// 			patient_sign: patient_sign,
// 			pharmacist_sign: pharmacist_sign,
// 			delivery_latitude: delivery_latitude,
// 			delivery_longitude: delivery_longitude,
// 			comment: comment,
// 			is_refused: is_refused,
// 			is_return: is_return,
// 			front_delivery_time: front_delivery_time,
// 		}

// 		if (hasFlexOnly === 'flexi_deliver') {
// 			payloadData.only_fexi = true
// 			payloadData.track_page = 'flexi_tab'
// 		} else {
// 			payloadData.only_fexi = false
// 			const typeMap = {
// 				today_dispense: 'today_dispense',
// 				pending_dispense: 'pending_dispense',
// 				patient_search_list: 'searched_dispense',
// 				today_missed: 'today_missed',
// 				final_missed: 'final_missed'
// 			};
// 			payloadData.track_page = typeMap[type] || '';
// 		}

// 		// if (frequency_dose_id ) {
// 		// 	payloadData.frequency_dose_id = frequency_dose_id
// 		// }

// 		if (frequency_dose_id && frequency_dose_id?.length > 0) {
// 			payloadData.frequency_dose_id = frequency_dose_id
// 		}

// 		if (isTransferRequest) {
// 			payloadData.to_pharmacy_id = pharmacy_id;
// 		}

// 		if (consultation) {
// 			payloadData.counsult_text = consultation?.value;
// 		}

// 		if (new_rx_counselling_values?.length > 0) {
// 			const newRxCounsellingValues = {};
// 			new_rx_counselling_values.forEach(({ rxid, dropdownValue }) => {
// 				if (dropdownValue?.value) {
// 					newRxCounsellingValues[rxid] = dropdownValue.value;
// 				}
// 			});
// 			payloadData.pending_counseling_note = newRxCounsellingValues;
// 		}

// 		if (flexi_rx_refill_id?.length > 0) {
// 			payloadData.flexi_rx_refill_id = flexi_rx_refill_id;
// 		}

// 		const response = await Axios.post(`${driver_confirm_delivery}/${patient_id}`, payloadData);
// 		const data = response

// 		if (typeof setShowSuccessToast === 'function'
// 			&& type !== 'pending_dispense'
// 			&& type !== 'today_dispense') {

// 			setShowSuccessToast(true)
// 			setTimeout(() => {
// 				setShowSuccessToast(false)
// 			}, 3000);
// 		}

// 		if (type === 'patient_search_list') {
// 			setTimeout(() => {
// 				window.history.back();
// 			}, 1000)
// 		}

// 		if (typeof setOpenIndex === 'function') {
// 			setOpenIndex(null)
// 		}

// 		if (typeof setIsTransferRequest === 'function') {
// 			setIsTransferRequest(null)
// 		}

// 		return data;

// 	} catch (error) {

// 		if (typeof setShowErrorToast === 'function') {
// 			setShowErrorToast(true)
// 			setTimeout(() => {
// 				setShowErrorToast(false)
// 			}, 3000);
// 		}

// 		if (type === 'pending_dispense') {
// 			if (typeof setLoading === 'function') {
// 				setLoading(true)
// 			}
// 			dispatch(clearData())
// 			dispatch(pendingDispenseRemovingPageNumber())
// 			dispatch(fetchPatientPendingList({
// 				page: 1,
// 				pharmacy_id: pharmacy_id,
// 				setLoading: setLoading
// 			}))
// 		}

// 		if (type === 'today_dispense') {

// 			dispatch(clearAllTodayDispenseData())
// 			dispatch(todayDispenseRemovingPageNumber())
// 			if (typeof requesteData.params.setLoading === 'function') {
// 				requesteData.params.setLoading(true)
// 			}
// 			const params = {
// 				route: requesteData?.params?.route,
// 				pharmacy_id: requesteData?.pharmacy_id,
// 				setLoading: requesteData?.params?.setLoading,
// 			}
// 			dispatch(fetchPatientlistOnBasisOfRoute(params))
// 		}
// 		return rejectWithValue(error.response)
// 	}
// });
